export default __webpack_public_path__ + "static/media/clap-icon.0a66daed.svg";